import React from 'react'

import { Card, Separator, theme, type TCardProps } from '@fe-toolkit/web-components/ssr'

import { DetailsListItem, type DetailsListItems } from '@giffgaff/broadband-common'

export type ListItemCardProps = TCardProps & {
  items: DetailsListItems
  children?: React.ReactNode
}

const ListItemCard = ({
  backgroundColor = 'white',
  padding = 'small',
  items,
  children,
  ...cardProps
}: ListItemCardProps) => {
  return (
    <Card backgroundColor={backgroundColor} padding={padding} {...cardProps}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <DetailsListItem label={item.label} value={item.value} />
          {index < items.length - 1 && (
            <Separator
              colour="gallery"
              height="1px"
              marginBottom={theme.spacing.small}
              marginTop={theme.spacing.small}
            />
          )}
        </React.Fragment>
      ))}
      {children}
    </Card>
  )
}

export default ListItemCard
